import { Navigate, NavigateProps, useLocation } from "react-router-dom";
import { FCC } from "types";

export const NavigateWithQueryParams: FCC<NavigateProps> = ({ to }) => {
  const { search } = useLocation();

  return <Navigate to={to + search} replace />;
};
